import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './components/App';
import reportWebVitals from './reportWebVitals';

process.env.NODE_ENV === 'development' && console.log('Development mode');
process.env.NODE_ENV === 'production' && console.log('Production mode');

const root = ReactDOM.createRoot(document.getElementById('dsg-gen-root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(console.log);
